module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_yxx-b70557a086d616550ce9efea95ab732a.png";